import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ConfiguracionGlobal, ConfiguracionService } from './configuracion.service';

/**
 * Deja la configuración global cargada ANTES de activar una ruta protegida.
 *
 * Sin esto, cada vista pedía la config en su `ngOnInit` al mismo tiempo que
 * disparaba sus cargas de datos: durante ese ida y vuelta `minMes`/`minAnio`
 * valían 0, así que el recorte por arranque de `PeriodoService` no aplicaba y
 * salían requests con un mes anterior al arranque (varias de un solo tiro, que
 * ya nunca se repetían). Resuelta la config primero, el periodo llega recortado
 * a la primera request.
 *
 * `getConfig()` está cacheada con `shareReplay(1)`: solo la primera navegación
 * paga el viaje al backend, las siguientes emiten y completan al instante. Si
 * falla, emite `null` y la navegación sigue — la app no se queda en blanco por
 * un backend caído (las vistas ya toleran no tener arranque).
 * @returns Observable que emite la configuración global, o `null` si no se pudo obtener.
 */
export const configuracionResolver: ResolveFn<ConfiguracionGlobal | null> = ():
    Observable<ConfiguracionGlobal | null> =>
    inject(ConfiguracionService)
        .getConfig()
        .pipe(catchError(() => of(null)));
